export default "<p>guardiasenturno works!</p>\n";